// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-3iQHsHjU","dbox":"dbox-22S9Mr1O"};